/**
 * ProDesignProjects Queries
 */

import gql from 'graphql-tag'

export const getBlogsQuery = gql`
  query getBlogs($limit: Int, $offset: Int, $searchText: String) {
    blogsQuery: getBlogs(limit: $limit, offset: $offset, fromCustomer: true, searchText: $searchText) {
      fullCount
      results {
        id
        title
        description
        desktopImage: desktop_image
        mobileImage: mobile_image
        created_at
        updated_at
        published_at
        likes
        dislikes
        content
        route
        icon
        userId: user_id
        visible
        category
        user_name
      }
    }
  }
`

export const updateLikeBlogMutation = gql`
  mutation updateLikeBlog($blogId: Int!, $isDislike: Boolean, $active: Boolean) {
    updateLikeBlog(blogId: $blogId, isDislike: $isDislike, active: $active) {
      message
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Blogs/data.ts